import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Select from "react-select";
import { FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";

const ModelMasterAdd = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Create Model"));
  }, []);

  const initialFormData = {
    BrandID: "",
    Model: "",
    Remark: "",
    IsInActive: 0,
    CategoryID: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [CategoryListOption, setCategoryListOption] = useState([]);
  const [brandListOption, setBrandListOption] = useState([]);
  const [selectedRating, setSelectedRating] = useState(null);

  useEffect(() => {
    fetchModelMasters();
  }, []);

  const fetchModelMasters = async () => {
    const response = await GetServiceCaller(`${API_URL}model-masters`);
    if (response.status === 200) {
      const fetchData = response?.data;
      const AssetCategory = fetchData?.assetCategoryList?.map((ele, index) => ({
        value: ele?.value,
        label: ele?.text,
      }));
      setCategoryListOption(AssetCategory);
      setPageLoading(false);
      setLoading(false);
    } else {
      console.error(
        "Failed to fetch model masters. Server responded with status:",
        response.status
      );
    }
  };

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      BrandID: null,
    }));

    if (formData.CategoryID) {
      fetchGetBrandsDetails(formData.CategoryID);
      setBrandListOption([]);
    }
  }, [formData.CategoryID]);
  const fetchGetBrandsDetails = async (id) => {
    try {
      const queryParams = new URLSearchParams({
        CategoryID: id,
      });
      const response = await GetServiceCaller(
        `${API_URL}get-brands?${queryParams.toString()}`
      );
      if (response.status === 200) {
        const fetchData = response?.data?.data;
        const brandlist = fetchData?.map((ele, index) => ({
          value: ele?.ID,
          label: ele?.Brand,
        }));
        setBrandListOption(brandlist);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch model masters. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("An error occurred while fetching brand details:", error);
    }
  };

  const schema = Yup.object().shape({
    BrandID: Yup.number()
      .typeError("Brand is required")
      .required("Brand is required"),
    Model: Yup.string().required("Model is required"),
    CategoryID: Yup.number()
      .typeError("Category is required")
      .required("Category is required"),
    Remark: Yup.string(),
  });
  const validateField = async (fieldName, updatedData) => {
    try {
      // Validate the specific field
      await schema.validateAt(fieldName, updatedData);

      // Clear the error for the specific field if validation is successful
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    } catch (err) {
      if (err.path === fieldName) {
        // Update the error only for the specific field
        setErrors((prevErrors) => ({
          ...prevErrors,
          [fieldName]: err.message,
        }));

        // Show error using toast for specific fields if needed
        if (fieldName.startsWith("lines")) {
          toast.error(err.message, { position: "top-right" });
        }
      } else {
        console.error("Validation error structure is not as expected:", err);
      }
    }
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    // Update form data only for fields in the schema
    if (schema.fields[name]) {
      setFormData((prevData) => {
        const updatedData = { ...prevData, [name]: value };
        validateField(name, updatedData);
        return updatedData;
      });
    }
  };

  // const handleChange = async (e) => {
  //   const { name, value } = e.target;

  //   // Update form data only for fields in the schema
  //   if (schema.fields[name]) {
  //     setFormData((prevData) => {
  //       const updatedData = { ...prevData, [name]: value };
  //       validateField(name, updatedData);
  //       return updatedData;
  //     });
  //   }
  // };
  const handleSelect = async (selectedOption, name) => {
    // Update formData with the selected value for the SkillID
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: selectedOption.value };
      // Trigger validation for the specific field after updating
      validateField(name, updatedData);
      return updatedData;
    });
  };
  // const handleRatingChange = (ratingValue) => {
  //   console.log("rating value is here", ratingValue);
  //   setSelectedRating(ratingValue);
  //   setFormData({
  //     ...formData,
  //     IsInActive: ratingValue == "Yes" ? 1 : 0,
  //   });
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Validate formData using schema
      await schema.validate(formData, { abortEarly: false });
      setErrors({}); // Clear previous errors

      // Call the API
      const response = await PostServiceCaller(
        `${API_URL}model-masters`,
        formData,
        "post"
      );

      if (response.status === 200) {
        toast.success("Data submitted successfully");
        // Redirect after a successful submission
        setTimeout(() => {
          navigate("/model-master");
        }, 2000);
      } else {
        console.error(
          "Failed to submit data. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      if (error.name === "ValidationError") {
        console.error("Validation Error:", error);
        const validationErrors = {};
        error.inner.forEach((err) => {
          validationErrors[err.path] = err.message;
        });
        setErrors(validationErrors);
      } else {
        console.error("Unexpected Error:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="Container">
            <form
              id="formOne"
              className="rounded bg-white mt-2"
              onSubmit={handleSubmit}
            >
              <div className="p-2">
                <div class="card-body  mx-2">
                  <div className="row">
                    <div className="col-md-4">
                      <label class="form-label">
                        Category<span className="text-danger">*</span>
                      </label>
                      <Select
                        name="CategoryID"
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        value={CategoryListOption?.find(
                          (o) => o.value === formData?.CategoryID
                        )}
                        className={` ${errors.CategoryID ? "is-invalid" : ""}`}
                        options={[
                          { value: null, label: "Select" },
                          ...CategoryListOption,
                        ]}
                      />
                      {errors.CategoryID && (
                        <div className="invalid-feedback">
                          {errors.CategoryID}
                        </div>
                      )}
                    </div>
                    <div className="col-md-4">
                      <label class="form-label">
                        Make<span className="text-danger">*</span>
                      </label>
                      <Select
                        name="BrandID"
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        value={
                          brandListOption?.find(
                            (o) => o.value === formData?.BrandID
                          ) || null
                        }
                        className={`${errors.BrandID ? "is-invalid" : ""}`}
                        options={[
                          { value: null, label: "Select" },
                          ...brandListOption,
                        ]}
                      />
                      {errors.BrandID && (
                        <div className="invalid-feedback">{errors.BrandID}</div>
                      )}
                    </div>
                    <div className="col-md-4">
                      <label class="form-label">
                        Model<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.Model ? "is-invalid" : ""
                        }`}
                        onChange={(e) => handleChange(e)}
                        name="Model"
                      />
                      {errors.Model && (
                        <div className="invalid-feedback">{errors.Model}</div>
                      )}
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-md-4">
                      <label class="form-label">Remark</label>
                      <textarea
                        name="Remark"
                        onChange={(e) => handleChange(e)}
                        className={`form-control ${
                          errors.Remark ? "is-invalid" : ""
                        }`}
                      />
                      {errors.Remark && (
                        <div className="invalid-feedback">{errors.Remark}</div>
                      )}
                    </div>
                    <div className="col-md-6 mt-4">
                      {/* <div className="d-flex gap-2 justify-content-start">
                        <label htmlFor="IsInActive" className="form-label">
                          Active
                        </label>
                        <div className="me-2 mt-0">
                          <div className="d-flex">
                            <div className="form-check me-2" key={"Yes"}>
                              <input
                                className="form-check-input"
                                type="radio"
                                name={`rating_1`}
                                id={`rating_1_yes`}
                                value={"Yes"}
                                checked={formData.IsInActive == 1 ? true : false}
                                onChange={() => handleRatingChange("Yes")}
                              />
                              <label className="form-check-label">Yes</label>
                            </div>
                            <div className="form-check me-2" key={"No"}>
                              <input
                                className="form-check-input"
                                type="radio"
                                name={`rating_1`}
                                id={`rating_1_No`}
                                value={"No"}
                                checked={formData.IsInActive == 0 ? true : false}
                                onChange={() => handleRatingChange("No")}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`rating_1_No`}
                              >
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                      </div> */}
                      <div className="col-4 mt-3 pt-1 d-flex">
                        <label className="form-label">Active</label>
                        <div>
                          <input
                            className="form-check-input ms-2 "
                            type="checkbox"
                            name="IsInActive"
                            id="flexSwitchCheckChecked"
                            checked={formData.IsInActive === 1}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                IsInActive: e.target.checked ? 1 : 0,
                              })
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="d-flex justify-content-end">
                      <div className="d-flex">
                        <div>
                          <button
                            type="button"
                            className="cancel-btn me-2"
                            onClick={() => navigate(`/model-master`)}
                          >
                            Cancel
                          </button>
                        </div>
                        <div>
                          <button
                            disabled={loading ? true : false}
                            type="submit"
                            className="custom-btn"
                          >
                            {loading ? (
                              <FaSpinner class="sm-spinner" />
                            ) : (
                              "Submit"
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
        </div>
      </>
    );
  }
};

export default ModelMasterAdd;
